import { skipIfNull } from '@proscom/prostore';
import { QUERY_CONTEST_DOCS_FOR_SS_MONITORING_PAGE } from '../../graphql/queries/contestDocsMonitoring';
import { useRetriableGraphqlVars } from '../../common/useRetriableGraphqlVars';

const contestDocsForSSMonitoringPageQueryOptions = {
  query: QUERY_CONTEST_DOCS_FOR_SS_MONITORING_PAGE,
  mapData: (data) => data.tenderDocumentationForSSPage,
  skipQuery: skipIfNull(null)
};

export function useContestDocsForSSMonitoringPage(filter, paginationParams) {
  return useRetriableGraphqlVars({
    queryOptions: contestDocsForSSMonitoringPageQueryOptions,
    variableCreator: [
      () =>
        filter
          ? {
              input: {
                filter: filter,
                pagination: paginationParams
              }
            }
          : null,
      [filter, paginationParams]
    ],
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
}
